<template>
    <PopupRouterView :showLeftIcon="true" label="Production Standar Time Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="productionstandartime"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="productionStandarTimeInput">


        <b-card header="Production Standar Time" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-standar-time-name" label-cols-lg="12"  label="Standar Time Name" label-for="input-standar-time-name" size="sm" :model.sync="model.standarTimeName" :isRequired="true" :state="validateState('standarTimeName')" :errorMessage="getErrorMessage(errorMessage.standarTimeName, 'standarTimeName')"   />
						<app-input-combobox-autocomplete :options="standarTimeCategorys" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Standar Time Category" id="fieldset-standar-time-category" size="sm" :model.sync="model.standarTimeCategoryId" :isRequired="true"    :selected="model.standarTimeCategory != null ? model.standarTimeCategory.code : ''" @input="getStandarTimeCategorys"   :isSelectMethodExists="true" @onSelectMethod="setSelectedStandarTimeCategory" />
						<app-input-textarea id="fieldset-remark" label-cols-lg="12"  label="Remark" label-for="input-remark" size="sm" :model.sync="model.remark"   />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>



        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ProductionStandarTime from '@/models/ProductionStandarTime/ProductionStandarTime';
import ProductionStandarTimeList from '@/models/ProductionStandarTime/ProductionStandarTimeList';
import ProductionStandarTimeFilter from '@/filters/ProductionStandarTime/ProductionStandarTimeFilter';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import StandarTimeCategory from '@/models/StandarTimeCategory/StandarTimeCategory';
import StandarTimeCategoryFilter from '@/filters/StandarTimeCategory/StandarTimeCategoryFilter';
import AppInputTextarea from '@/components/AppInputTextarea';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputTextbox,
		AppInputComboboxAutocomplete,
		AppInputTextarea,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			standarTimeName: {required},
			//standarTimeCategoryId: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				standarTimeName: { required : "Standar Time Name is Required."},
				standarTimeCategoryId: { required : "Standar Time Category is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterProductionStandarTime : null,
			currentProductionStandarTimePage : 1,
			productionStandarTimePageSize: 10,
			sortByProductionStandarTime: '',
			sortDescProductionStandarTime: '',
			standarTimeCategorys: [],
			standarTimeCategorys: [],
			isStandarTimeCategoryComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isStandarTimeCategoryComboLoading: false,
		}
	},
	methods : {
		getProductionStandarTime : async function(id) {
			this.isBusy = true;
			ProductionStandarTime.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadProductionStandarTime = true;
			this.filterProductionStandarTime.id = this.modelId;
			ProductionStandarTime.downloadDataDetail(this, this.filterProductionStandarTime).then(result => {
				this.isDownloadProductionStandarTime = false;
			}).catch(error => { this.isDownloadProductionStandarTime = false; })
		},
		getProductionStandarTimes : async function(input) {
			let filter = new ProductionStandarTimeFilter();
			if (input != undefined) {
				filter.StandarTimeName = input;
			}
			this.isProductionStandarTimeComboLoading = true;
			ProductionStandarTime.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.productionStandarTimes = result.data
				}
				this.isProductionStandarTimeComboLoading = false;
			})
			.catch(error => {});
		},
		getStandarTimeCategorys : async function(input) {
			let filter = new StandarTimeCategoryFilter();
			if (input != undefined) {
				filter.code = input;
			}
			StandarTimeCategory.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.standarTimeCategorys = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedStandarTimeCategory(item) {
			if(item == undefined || item == null) {
				this.model.standarTimeCategoryId = null;
				this.model.standarTimeCategory = null;
			} else {
				this.model.standarTimeCategoryId = item.id;
				this.model.standarTimeCategory = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.productionStandarTimeInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						ProductionStandarTime.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'productionstandartimeindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						ProductionStandarTime.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'productionstandartimeindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					ProductionStandarTime.updateData(this, model, id)
					.catch((error) => {
						this.getProductionStandarTime(id);
					});
				}
			});
		},
		onHidden() {
			this.getProductionStandarTimes();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterProductionStandarTime = new ProductionStandarTimeFilter();
		//this.getStandarTimeCategorys();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getProductionStandarTime(id);
			} else {
				this.modelId = id;
				this.getProductionStandarTime(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
	},
}
</script>
